import { Link, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import Auth from '../services/auth';
import ScoringView from './pages/scoring';
import PubmedSearch from './pages/pubmedSearch';
import Validation from './pages/validation';
import PipelineRun from './pages/pipelineRun';
import ArticleDetails from './pages/article';
import ArticlePDFViewer from './pages/article/pdf';
import ValidationView from './pages/validation/detailView';
import Experiment from './pages/experiments';
import ReferenceCheck from './pages/referenceCheck';
import ValidationV2 from './pages/validationV2';
import ValidationV2View from './pages/validationV2/detailView';
import ApproveChanges from './pages/approveChanges';

const Header = () => {
  const auth = new Auth();
  const navigate = useNavigate();
  const pages = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Scoring', path: '/scoring' },
    { label: 'Pubmed Search', path: '/pubmed' },
    { label: 'Validation', path: '/validationV2' },
    { label: 'Pipeline Run', path: '/pipeline-run' },
    { label: 'Approve Changes', path: '/approve-changes' },
  ];
  let location = useLocation();
  let pathname = location.pathname;

  let activePage = pages.find((page) => pathname.startsWith(page.path))?.path;
  return (
    <div className="flex justify-between items-center ">
      <img src="/reboot-logo.png" style={{ height: '50px', marginTop: '0.5rem' }} />
      <div className="flex gap-12 items-center">
        {pages.map((page) => (
          <Link
            to={page.path}
            key={page.path}
            className={`text-sm ${activePage === page.path ? 'text-blue-500 font-semibold' : 'text-neutral-500'}`}
          >
            {page.label}
          </Link>
        ))}
        <button
          className="text-sm text-neutral-500 transition hover:text-blue-500"
          onClick={() => {
            auth.logout();
            navigate('/');
            window.location.reload();
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

const Root = () => {
  return (
    <div className="flex flex-col h-screen max-w-screen-2xl mx-auto px-6">
      <div className="">
        <Header />
      </div>
      <div className="flex-1 overflow-y-auto pt-4">
        <Outlet />
      </div>
    </div>
  );
};

let v2Router = {
  path: '/',
  element: <Root />,
  children: [
    {
      index: true,
      element: <Navigate to="/dashboard" replace />,
    },
    {
      path: 'dashboard',
      element: <Dashboard />,
    },
    {
      path: 'scoring',
      element: <ScoringView />,
    },
    {
      path: 'article/:articleId',
      element: <ArticleDetails />,
    },
    {
      path: 'article/:articleId/pdf',
      element: <ArticlePDFViewer />,
    },
    {
      path: 'pubmed',
      element: <PubmedSearch />,
    },
    {
      path: 'validation',
      element: <Validation />,
    },
    {
      path: 'validationV2',
      element: <ValidationV2 />,
    },
    {
      path: 'validationV2/:id',
      element: <ValidationV2View />,
    },
    {
      path: 'validation/:id',
      element: <ValidationView />,
    },
    {
      path: 'pipeline-run',
      element: <PipelineRun />,
    },
    {
      path: 'experiments',
      element: <Experiment />,
    },
    {
      path: 'references',
      element: <ReferenceCheck />,
    },
    {
      path: 'approve-changes',
      element: <ApproveChanges />,
    },
  ],
};

export default v2Router;
